// material-ui
import { Grid, Typography } from '@mui/material';

// project imports
import MainCard from 'ui-component/cards/MainCard';
import { useTheme } from '@mui/material/styles';
import HoverSocialCard from '../../../ui-component/cards/HoverSocialCard';
import KeyboardIcon from '@mui/icons-material/Keyboard';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import ImportContactsIcon from '@mui/icons-material/ImportContacts';

// ==============================|| SAMPLE PAGE ||============================== //

const Form1099R = () => {
    const theme = useTheme();
    return (
        <Grid container spacing={3}>
            <Grid item xs={12} lg={4} sm={6}>
                <HoverSocialCard
                    primary="Add Business Details"
                    secondary="Manual Entry"
                    iconPrimary={KeyboardIcon}
                    color={theme.palette.orange.dark}
                />
            </Grid>
            <Grid item xs={12} lg={4} sm={6}>
                <HoverSocialCard
                    primary="Import Employer Details"
                    secondary="Bulk Upload"
                    iconPrimary={CloudUploadIcon}
                    color={theme.palette.secondary.dark}
                />
            </Grid>
            <Grid item xs={12} lg={4} sm={6}>
                <HoverSocialCard
                    primary="Import From QuickBook"
                    secondary="Quick Book"
                    iconPrimary={ImportContactsIcon}
                    color={theme.palette.secondary.main}
                />
            </Grid>
        </Grid>
    );
};

export default Form1099R;
